var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.8 2.097h-3.048V.683A.683.683 0 0 0 16.07 0h-2.732a.683.683 0 0 0-.682.683v1.414H7.828V.683A.683.683 0 0 0 7.145 0H4.414a.683.683 0 0 0-.683.683v1.414H.683A.683.683 0 0 0 0 2.78v15.704a.683.683 0 0 0 .683.682H19.8a.683.683 0 0 0 .683-.682V2.78a.683.683 0 0 0-.683-.683m-5.779-.731h1.366v3.78H14.02zm-8.924 0h1.365v3.78H5.097zM1.366 3.462H3.73v2.366a.683.683 0 0 0 .683.683h2.731a.683.683 0 0 0 .683-.683V3.462h4.828v2.366a.683.683 0 0 0 .682.683h2.732a.683.683 0 0 0 .682-.683V3.462h2.366V7.5H1.366zm17.752 14.339H1.366V8.866h17.752z"
  })));
};
export default SvgCalendar;